import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------常见问题---------------------------- */

  //课程级别类型
  levelsList() {
    return request({
      url: `${resquest}/novel/public/course/levels`,
      method: 'get'
    })
  },
  //课程列表
  classroomList(params) {
    return request({
      url: `${resquest}/novel/public/course/list`,
      method: 'get',
      params
    })
  },
  //课程详情
  classroomDetail(params) {
    return request({
      url: `${resquest}/novel/public/course/details`,
      method: 'get',
      params
    })
  },
  //购买课程(PC)
  payClassroom(data) {
    return request({
      url: `${resquest}/novel/pc/pay/course`,
      method: 'post',
      data
    })
  },
  //已购课程-购买记录
  classroomBuyHistory(params) {
    return request({
      url: `${resquest}/novel/app/course/payed`,
      method: 'get',
      params
    })
  },
}